import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { customAlphabet } from "nanoid";
import { useHistory, useLocation } from "react-router-dom";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Save } from "@material-ui/icons";
import dateFnsFormat from "date-fns/format";
import ApplicantDto from "./ApplicantDto";
import ParentsDetails from "./ParentsDetails";
import OtherDetails from "./OtherDetails";
import WebApi, { NSDL_PROCESS_RESPONSE, NSDL_NEW_PAN_REQUEST } from "api/ApiConstants";
import { apiCall } from "oautils/oaDataUtils";
import OaPopperAlert from "oahoc/OaPopperAlert";
import OaSnackbar from "oahoc/OaSnackbar";
import { EXT_REDIRECT_SERVER } from "api/ApiConstants";

const PanRequestForm = (props) => {
    const classes = useStyles();
    const formikRef = React.useRef();

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const errorValue = params.get("error");
    const txnId = params.get("txnId");
    const history = useHistory();

    const [severity, setSeverity] = React.useState({
        issuccess: false,
        iserror: false,
        iswarning: false,
        isinfo: false
    });
    const [severitySnackbar, setSeveritySnackbar] = React.useState({
        issuccess: false,
        iserror: false,
        iswarning: false,
        isinfo: false
    });
    const [alertMessage, setAlertMessage] = React.useState("");
    const [finalFormData, setFinalFormData] = React.useState(null);
    const [tempTokenNo, setTempTokenNo] = React.useState(null);
    const [initialFormData, setInitialFormData] = React.useState(initData);

    const getUniqueTransactionNumber = () => {
        const alphabet = "0123456789";
        const generateId = customAlphabet(alphabet, 14);
        return generateId();
    };

    const saveDraft = (values) => {
        // console.log("draft values", values);
        values.applicantDto.created_at = dateFnsFormat(new Date(), "yyyy-MM-dd HH:mm:ss");
        values.applicationType = tempTokenNo ? "DA" : history.location.state.appliType.value;

        WebApi.nsdlPanRequestSaveDraft(values, response => {
            if(response.success) {
                formikRef.current.setFieldValue("applicantDto.tokenNo", ""+response.data);
                setTempTokenNo(response.data);
                setAlertMessage(response.message);
                setSeverity({
                    ...severity,
                    issuccess: true
                });
            } else {
                console.log("server error", response.message);
                setAlertMessage(response.message);
                setSeverity({
                    ...severity,
                    issuccess: false,
                    iserror: true
                });
            }
        }, error => { console.log("error", error) });
    };

    const proceedToPayment = (values) => {
        history.push("/pan/payment-details", {
            values: values,
            applicationType: tempTokenNo ? "DA" : history.location.state.appliType.value,
            applicationCategory: history.location.state.category.value,
            payableAmount: values.otherDetails.phyPanIsReq == "1" ? 107.00 : 72.00
        });
    };

    const submitForm = (values) => {
        delete values.applicantDto.dobDisplay;
        delete values.otherDetails.dateDisplay;
        // console.log("values", values);

        WebApi.nsdlSignRequest({
            formData: JSON.stringify(values),
            redirectUrl: NSDL_PROCESS_RESPONSE,
            siteUrl: EXT_REDIRECT_SERVER + "pan/application/response/",
            requestType: "CR",
            txnId: getUniqueTransactionNumber()
        }, response => {
            if(response.success) {
                setFinalFormData(response.data);
                setAlertMessage("Processing application form for submission...");
                setSeveritySnackbar({
                    ...severitySnackbar,
                    issuccess: true
                });
            } else {
                console.log("error response", response);
                setAlertMessage(response.message);
                setSeverity({
                    ...severity,
                    iserror: true
                });
            }
        }, error => {
            console.log("error", error);
        });
    };

    const submitToNsdl = () => {
        var formElement = document.createElement("form");
        formElement.setAttribute("method", "post");
        formElement.setAttribute("action", NSDL_NEW_PAN_REQUEST);
        formElement.setAttribute("target", "_parent");

        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "req");
        hiddenField.setAttribute("value", finalFormData);
        formElement.appendChild(hiddenField);

        document.body.appendChild(formElement);
        formElement.submit();
    }

    React.useEffect(() => {
        if(history.location.state.token && history.location.state.draft) {
            setTempTokenNo(history.location.state.token);
            let initialData = history.location.state.draft;

            delete initialData.applicantDto.id;
            delete initialData.applicantDto.created_at;
            delete initialData.applicantDto.tid;
            delete initialData.parentsDetails.tid;
            delete initialData.parentsDetails.token_number;
            delete initialData.otherDetails.tid;
            delete initialData.otherDetails.token_number;
            delete initialData.otherDetails.officeAddress.tid;
            delete initialData.otherDetails.officeAddress.token_number;
            delete initialData.otherDetails.raAddress.tid;
            delete initialData.otherDetails.raAddress.token_number;
            delete initialData.otherDetails.residenceAddress.tid;
            delete initialData.otherDetails.residenceAddress.token_number;
            delete initialData.otherDetails.sourceOfIncome.tid;
            delete initialData.otherDetails.sourceOfIncome.token_number;
            delete initialData.amountDue;
            delete initialData.applicationType;
            delete initialData.encTxnId;
            delete initialData.loggedInUserId;
            delete initialData.partnerId;
            delete initialData.paymentMode;
            delete initialData.paymentUrl;
            delete initialData.redirectUrl;
            delete initialData.requestType;
            delete initialData.siteUrl;
            delete initialData.tempTokenNo;
            delete initialData.txnId;
            delete initialData.userType;

            Object.keys(initialData).map(val => {
                switch(val) {
                    case "applicantDto": {
                        let dob = initialData[val].dob.split("/");
                        initialData[val]["dobDisplay"] = new Date(dob[2]+"-"+dob[1]+"-"+dob[0]);
                        break;
                    }
                    case "otherDetails": {
                        initialData[val].date = dateFnsFormat(new Date(), "dd/MM/yyyy");
                        initialData[val]["dateDisplay"] = new Date();
                        break;
                    }
                }
            });

            setInitialFormData(initialData)
        }
    }, []);

    React.useEffect(() => {
        if(finalFormData && finalFormData !== "") {
            submitToNsdl();
        }
    }, [finalFormData]);

    return (
        <Box className={classes.root}>
            <Formik
                innerRef={formikRef}
                initialValues={initialFormData}
                validationSchema={SignupSchema}
                onSubmit={proceedToPayment}
            >
                {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                        {/* <div className="formContainer" style={{wordWrap: "break-word"}}>
                            {JSON.stringify(values)}<br/>
                            {JSON.stringify(errors)}
                        </div> */}
                        {console.log(errors)}
                        <div className="formContainer">
                            <div className="form-header">
                                <div className="form-group application-summary">
                                    <Typography className="h1-text">Online PAN Application</Typography>
                                    <Typography className="normal-text">
                                        Application Type: <b>{history.location.state.appliType.label}</b>
                                    </Typography>
                                    <Typography className="normal-text">
                                        Category: <b>{history.location.state.category.label}</b>
                                    </Typography>
                                    {tempTokenNo &&
                                    <Typography className="normal-text">
                                        Temporary Token Number: <b>{tempTokenNo}</b>
                                    </Typography>}
                                </div>
                                <div className="form-group action-group">
                                    <a onClick={() => saveDraft(values)}>
                                        <Save/> Save Draft
                                    </a>
                                </div>
                            </div>
                            {/* <div className="hr-line"></div> */}
                            <div className="form-body">
                                <ApplicantDto
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />
                                <ParentsDetails
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />
                                <OtherDetails
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />
                                {/* <div className="form-section-root">
                                    <div className="form-row flex-row justify-content-center">
                                        <div className="form-group col-25 action-group ta-center">
                                            <Button
                                                type="submit"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <OaPopperAlert
                alertmessage={alertMessage}
                severity={severity}
                setseverity={setSeverity}
            />
            <OaSnackbar
                alertmessage={alertMessage}
                severity={severitySnackbar}
                setseverity={setSeveritySnackbar}
                vertical="bottom"
                horizontal="right"
                autoHideDuration={6000}
            />
        </Box >
    );
};

export default PanRequestForm;

const initData = {
    applicantDto: {
        appliType: "A",
        category: "A",
        title: 1,
        lastName: "rabha",
        firstName: "dhananjoy",
        middleName: "",
        dob: "16/01/1988",
        dobDisplay: new Date("1988-01-16"),
        gender: "M",
        consent: "yes",
        nameOnPanCard: "dhananjoy rabha",
        knownByOtherName: "N",
        otherTitle: "0",
        otherLastName: "",
        otherFirstName: "",
        otherMiddleName: "",
        tokenNo: "",
        nameAsPerAadhar: "",
        applnMode: ""
    },
    parentsDetails: {
        singleParent: "0",
        fatherLastName: "testlf",
        fatherFirstName: "testff",
        fatherMiddleName: "",
        motherLastName: "testlm",
        motherFirstName: "testlm",
        motherMiddleName: "",
        parentNamePrint: "F",
        reEnterFatherLastName: "testlf",
        reEnterFatherFirstName: "testff",
        reEnterFatherMiddleName: "",
        reEnterMotherLastName: "testlm",
        reEnterMotherFirstName: "testlm",
        reEnterMotherMiddleName: ""
    },
    otherDetails: {
        phyPanIsReq: "N",
        sourceOfIncome: {
            salary: 'N',
            otherSource: '0',
            businessProf: '',
            businessPrfCode: "",
            noIncome: '',
            housePro: '',
            capitalGains: ''
        },
        addrForCommunication: "R",
        officeAddress: {
            flatNo: "",
            nameOfPremises: "",
            road: "",
            area: "",
            town: "",
            countryName: "none",
            state: "none",
            pinCode: "",
            zipCode: "",
            officeName: ""
        },
        isdCode: "91",
        stdCode: "",
        telOrMobNo: "9711392985",
        emailId: "vincent@oari.co",
        place: "",
        date: dateFnsFormat(new Date(), "dd/MM/yyyy"),
        dateDisplay: new Date(),
        raValue: "",
        raTitle: "",
        raLastName: "",
        raFirstName: "",
        raMiddleName: "",
        raAddress: {
            raFlatNo: "",
            raNameOfPremises: "",
            raRoad: "",
            raArea: "",
            raTown: "",
            raCountryName: "none",
            raState: "none",
            raPinCode: "",
            raZipCode: ""
        },
        residenceAddress: {
            rflatNo: "",
            rnameOfPremises: "",
            rroad: "",
            rarea: "",
            rtown: "",
            rcountryName: "none",
            rstate: "none",
            rpinCode: "",
            rzipCode: ""
        }
    },
    aoCode: {
        areaCode: "",
        aoType: "",
        rangeCode: "",
        aoNo: ""
    }
};

const SignupSchema = Yup.object().shape({
    applicantDto: Yup.object().shape({
        title: Yup.number().required('Mandatory'),
        lastName: Yup.string(),
        firstName: Yup.string().required('Mandatory'),
        dob: Yup.string().required('Mandatory'),
        gender: Yup.string().required('Mandatory'),
        nameOnPanCard: Yup.string().required('Mandatory'),
        knownByOtherName: Yup.string().required('Mandatory'),
        otherTitle: Yup.string().when("knownByOtherName", {
            is: v => { return v == "Y" },
            then: Yup.string().required("mandatory")
        }),
        otherLastName: Yup.string().when("knownByOtherName", {
            is: v => { return v == "Y" },
            then: Yup.string().required("mandatory")
        }),
        // otherFirstName: Yup.string().when("otherMiddleName", {
        //     is: v => { return v != "" },
        //     then: Yup.string().required("mandatory")
        // }),
        nameAsPerAadhar: Yup.string().when("applnMode", {
            is: v => { return v == "E" },
            then: Yup.string().required("mandatory")
        })
    }),
    parentsDetails: Yup.object().shape({
        singleParent: Yup.string().required('Mandatory'),
        fatherLastName: Yup.string().when('singleParent', {
            is: v => { return v == "0" },
            then: Yup.string().required("mandatory")
        }),
        fatherFirstName: Yup.string().when('singleParent', {
            is: v => { return v == "0" },
            then: Yup.string().required("mandatory")
        }),
        reEnterFatherLastName: Yup.string().when('singleParent', {
            is: v => { return v == "0" },
            then: Yup.string().required("mandatory")
        }),
        reEnterFatherFirstName: Yup.string().when('singleParent', {
            is: v => { return v == "0" },
            then: Yup.string().required("mandatory")
        }),
        motherLastName: Yup.string().when('singleParent', {
            is: v => { return v == "1" },
            then: Yup.string().required("mandatory")
        }),
        motherFirstName: Yup.string().when('singleParent', {
            is: v => { return v == "1" },
            then: Yup.string().required("mandatory")
        }),
        reEnterMotherLastName: Yup.string().when('singleParent', {
            is: v => { return v == "1" },
            then: Yup.string().required("mandatory")
        }),
        reEnterMotherFirstName: Yup.string().when('singleParent', {
            is: v => { return v == "1" },
            then: Yup.string().required("mandatory")
        }),
    }),
    otherDetails: Yup.object().shape({
        phyPanIsReq: Yup.string().required("mandatory"),
        sourceOfIncome: Yup.object().shape({
            businessPrfCode: Yup.string().when("businessProf", {
                is: v => { return v == "d" },
                then: Yup.string().required("mandatory")
            })
        }),
        addrForCommunication: Yup.string().required("mandatory")
    })
});

const useStyles = makeStyles(theme => ({
    root: {
        "& .formContainer": {
            width: 1200,
            marginLeft: "auto",
            marginRight: "auto",
            fontFamily: theme.palette.font.primary,
            padding: "25px 30px",
            "& p, a, label": {
                fontFamily: theme.palette.font.primary,
            },
            "& .imp": {
                color: theme.palette.primary.danger
            },
            [theme.breakpoints.down(1200)]: {
                width: "100%"
            }
        },
        "& .form-row": {
            margin: "15px 0"
        },
        "& .form-header": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            [theme.breakpoints.down(600)]: {
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "center",
                gap: 20
            }
        },
        "& .form-header-row": {
            background: theme.palette.tertiary.main,
            color: theme.palette.tertiary.contrastText,
            padding: "5px 10px"
        },
        "& .form-group": {
            "& .form-radio-group": {
                flexDirection: "row",
                gap: 10
            },
            "&.select-inp, & .select-inp": {
                "& .MuiInputBase-root, .MuiOutlinedInput-root": {
                    marginTop: 5
                }
            }
        },
        "& .check-box-group": {
            "& .MuiTypography-root": {
                width: 100
            }
        },
        "& .application-summary": {
            fontFamily: theme.palette.font.primary,
        },
        "& .action-group": {
            "& a": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                height: 36,
                background: theme.palette.quarternary.main,
                width: 115,
                color: theme.palette.quarternary.contrastText,
                borderRadius: 25,
                cursor: "pointer"
            },
            "& .MuiSvgIcon-root": {
                fontSize: "1.2rem",
                marginRight: 2
            },
            "& .MuiButtonBase-root": {
                fontSize: 12,
                height: 36,
                background: theme.palette.quarternary.main,
                width: 115,
                color: theme.palette.quarternary.contrastText,
                borderRadius: 25,
                cursor: "pointer"
            }
        },
        "& .h1-text": {
            fontSize: "1.5rem",
            fontWeight: 500
        },
        "& .normal-text": {
            fontSize: "0.9rem"
        },
        "& .hr-line": {
            width: "100%",
            borderBottom: `solid 2px ${theme.palette.tertiary.main}`,
            margin: "10px 0"
        },
        "& .flex-row": {
            display: "flex",
            [theme.breakpoints.down(768)]: {
                flexDirection: "column"
            }
        },
        "& .gap-10": {
            gap: 10
        },
        "& .no-wrap": {
            flexWrap: "nowrap"
        },
        "& .col-24": {
            width: "24%",
            [theme.breakpoints.down(992)]: {
                width: "50%"
            },
            [theme.breakpoints.down(768)]: {
                width: "100%"
            }
        },
        "& .col-25": {
            width: "25%",
            [theme.breakpoints.down(992)]: {
                width: "50%"
            },
            [theme.breakpoints.down(768)]: {
                width: "100%"
            }
        },
        "& .col-33": {
            width: "33%",
            [theme.breakpoints.down(992)]: {
                width: "50%"
            },
            [theme.breakpoints.down(768)]: {
                width: "100%"
            }
        },
        "& .col-50": {
            width: "50%",
            [theme.breakpoints.down(992)]: {
                width: "50%"
            },
            [theme.breakpoints.down(768)]: {
                width: "100%"
            }
        },
        "& .col-100": {
            width: "100%",
        },
        "& .justify-content-center": {
            justifyContent: "center"
        },
        "& .ta-left": {
            textAlign: "left",
            [theme.breakpoints.down(768)]: {
                textAlign: "center",
            }
        },
        "& .ta-right": {
            textAlign: "right",
            [theme.breakpoints.down(768)]: {
                textAlign: "center",
            }
        },
        "& .ta-center": {
            textAlign: "center"
        },
        "& .pt-30": {
            paddingTop: 30
        }
    }
}));
